import React, { useState, useContext } from "react";
import { sendFilterOrderPurchasesData } from "../../../apis/apis.logistics/apisProduct";
import { getCurrentDate } from "../../../configs/helpers";
import { toast } from "react-toastify";
import { ContextAuth } from "../../../contexts/ContextAuth";

const inputClass = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";

export function OrderPurchaseFilter({ setOrders }) {
    const { auth } = useContext(ContextAuth);
    const sendFilterOrderPurchases = async (data) => {
        try {
            const response = await sendFilterOrderPurchasesData(data);
            console.log(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const [questionState, setQuestionState] = useState({
        options: [{ radioName: "actions", selected: "" }],
        suggest: "",
        startDate: getCurrentDate("-"),
        endDate: getCurrentDate("-"),
        subsidiaryID: auth.data.subsidiary.subsidiary_id,
    });

    const handleChange = (e) => {
        const { options } = questionState;
        const { name, value } = e.target;

        const nextState = options.map((opt) => {
            if (opt.radioName !== name) {
                return { ...opt };
            } else {
                return { ...opt, selected: value };
            }
        });

        setQuestionState({ ...questionState, options: nextState });
    };

    function handleChangeSuggest(e) {
        setQuestionState({ ...questionState, suggest: e.target.value });
    }

    function handleChangeDate(e) {
        setQuestionState({ ...questionState, [e.target.name]: e.target.value });
    }

    const handleKeyDownSupplier = async (e) => {
        if (e.keyCode === 13) {
            searchSuggestions();
        }
    };

    const handleQuery = (e) => {
        searchSuggestions();
    };

    function searchSuggestions() {
        sendFilterOrderPurchases(questionState).then((res) => {
            let results = res.length;
            toast.info(
                results > 1
                    ? "Se encontraron " + results.toString() + " resultados."
                    : "Se encontró " + results.toString() + " resultado(s).",
            );
            setOrders(res);
        });
    }

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden mb-4">
            <div className="p-5">
                <div className="flex flex-col gap-4">
                    <div className="flex flex-wrap items-center gap-3">
                        <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                            Buscar por:
                        </span>
                        <div className="flex items-center gap-4">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="actions"
                                    value="id"
                                    onChange={handleChange}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600 focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-700 dark:text-gray-300">
                                    ID
                                </span>
                            </label>
                            <span className="text-gray-400">/</span>
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="actions"
                                    value="supplierName"
                                    onChange={handleChange}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600 focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-700 dark:text-gray-300">
                                    Proveedor
                                </span>
                            </label>
                            <span className="text-gray-400">/</span>
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="radio"
                                    name="actions"
                                    value="supplierDocumentNumber"
                                    onChange={handleChange}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600 focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-700 dark:text-gray-300">
                                    RUC
                                </span>
                            </label>
                        </div>
                    </div>

                    <div className="flex flex-col md:flex-row gap-3 items-end">
                        <div className="flex-1">
                            <input
                                type="text"
                                className={inputClass}
                                name="suggest"
                                placeholder="Ingrese texto (mínimo 3 caracteres)"
                                onChange={handleChangeSuggest}
                                onKeyDown={handleKeyDownSupplier}
                                maxLength={50}
                                autoComplete="off"
                            />
                        </div>
                        <span className="text-gray-400 text-sm hidden md:block">y/o</span>
                        <div className="flex gap-3 flex-1">
                            <input
                                type="date"
                                name="startDate"
                                className={inputClass}
                                value={questionState.startDate}
                                onChange={handleChangeDate}
                            />
                            <input
                                type="date"
                                name="endDate"
                                className={inputClass}
                                value={questionState.endDate}
                                onChange={handleChangeDate}
                            />
                        </div>
                        <button
                            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onClick={handleQuery}
                            id="btn-filter"
                        >
                            <i className="fas fa-search"></i>
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
